<template>
  <!-- A pinned date range in the filter bar, drawn exactly like the bar's own
       date box (FilterBar.vue, `kf-bar__date`) so two ranges side by side --
       Leads' Applied on and Disbursement date -- read as one pair. DateField
       is the panel's control: a different icon and a 16px label. -->
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        :value="text"
        :label="title"
        :aria-label="title"
        prepend-inner-icon="mdi-calendar"
        readonly
        hide-details
        dense
        outlined
        :clearable="isSet"
        v-bind="attrs"
        v-on="on"
        @click:clear="clear"
      />
    </template>
    <v-date-picker
      v-model="local"
      range
      no-title
      color="primary"
      :max="max"
      @change="onChange"
    />
  </v-menu>
</template>

<script>
import fmt from "@/app-js/karrofin/format";

export default {
  name: "KfBarDateRange",
  props: {
    /** [from, to] as yyyy-mm-dd, or [] for no range. */
    value: { type: Array, default: () => [] },
    title: { type: String, required: true },
    max: { type: String, default: undefined },
  },
  data() {
    return { menu: false, local: (this.value || []).slice() };
  },
  computed: {
    isSet() {
      return !!(this.value && this.value.length === 2);
    },
    /* "All dates" rather than empty, as the bar's own box: the label then
       always sits on the border, and an empty box never reads as broken. */
    text() {
      return this.isSet ? fmt.dateRangeShort(this.value[0], this.value[1]) : "All dates";
    },
  },
  watch: {
    value(next) {
      this.local = (next || []).slice();
    },
  },
  methods: {
    clear() {
      this.local = [];
      this.$emit("input", []);
      this.$emit("change");
    },
    onChange() {
      if (this.local.length !== 2) return;
      // v-date-picker hands the range back reversed when the later day is
      // picked first, and an unsorted pair matches nothing.
      const sorted = this.local.slice().sort();
      this.menu = false;
      this.$emit("input", sorted);
      this.$emit("change");
    },
  },
};
</script>
